module.exports = __webpack_public_path__ + "img/IMG_0300_L_Wood.0642a488.jpg";